module.exports = __webpack_public_path__ + "static/media/room-number.85bb36c6.jpg";